import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";
import useLocales from "src/hooks/useLocales";

const Report = Loadable(lazy(() => import("src/pages/reports/index")));
const FundReport = Loadable(lazy(() => import("src/pages/reports/fund/index")));
const BuilderReport = Loadable(
  lazy(() => import("src/pages/reports/builder/index"))
);
const PayoutReport = Loadable(
  lazy(() => import("src/pages/reports/payout/index"))
);

const PointReport = Loadable(
  lazy(() => import("src/pages/reports/point/index"))
);
const SalesReport = Loadable(
  lazy(() => import("src/pages/reports/sales/index"))
);
const JoiningReport = Loadable(
  lazy(() => import("src/pages/reports/joining/index"))
);

const IncomeReport = Loadable(
  lazy(() => import("src/pages/reports/income/index"))
);

const TopEarnersReport = Loadable(
  lazy(() => import("src/pages/reports/topEarners/index"))
);

const ManualRankUpdate = Loadable(
  lazy(() => import("src/pages/reports/manualRankUpdate/index"))
);

const InvoiceReport = Loadable(
  lazy(() => import("src/pages/reports/invoice/index"))
);

const reports = [
  {
    path: "report",
    element: <Report />,
    children: [
      {
        element: <Navigate to="builder" />,
        index: true,
      },
      {
        path: "builder",
        element: (
          <BuilderReport
            title="report.businessBuilderReport"
            heading="report.businessBuilderReport"
          />
        ),
      },
      {
        path: "fund/credit",
        element: (
          <FundReport
            title="report.fundCreditReport"
            heading="report.fundCreditReport"
          />
        ),
      },
      {
        path: "joining",
        element: (
          <JoiningReport
            title="report.joiningReport"
            heading="report.joiningReport"
          />
        ),
      },
      {
        path: "income",
        element: (
          <IncomeReport
            title="report.memberIncomeReport"
            heading="report.memberIncomeReport"
          />
        ),
      },
      {
        path: "payout",
        element: (
          <PayoutReport
            title="report.payoutReport"
            heading="report.payoutReport"
          />
        ),
      },

      {
        path: "point/history",
        element: (
          <PointReport
            title="report.pointHistoryReport"
            heading="report.pointHistoryReport"
          />
        ),
      },
      {
        path: "earners",
        element: (
          <TopEarnersReport
            title="report.topEarnersReport"
            heading="report.topEarnersReport"
          />
        ),
      },
      {
        path: "sales",
        element: (
          <SalesReport
            title="report.salesReport"
            heading="report.salesReport"
          />
        ),
      },
      {
        path: "manual-rank-update",
        element: (
          <ManualRankUpdate
            title="latest.manualRankUpdateReport"
            heading="latest.manualRankUpdateReport"
          />
        ),
      },
      {
        path: "invoice",
        children: [
          { index: true, element: <Navigate to="1" /> },
          {
            path: ":id",
            element: (
              <InvoiceReport
                title="Invoice Report"
                heading="Invoice Report"
              />
            ),
          },
        ],
      },
    ],
  },
];

export default reports;
